import { api } from './api.js';
import { ENDPOINTS } from '../config/endpoints.js';
import { tokenService } from './tokenService.js';

/**
 * Serviço de autenticação Admin
 */
export const authService = {
  /**
   * Login do admin
   */
  async login(email, password) {
    try {
      const response = await api.post(ENDPOINTS.ADMIN_LOGIN, {
        email,
        password,
      });

      if (response.data.error) {
        throw new Error(response.data.response || 'Credenciais inválidas');
      }

      const userData = response.data.response;
      tokenService.setToken(userData.token);
      tokenService.setUserData({
        id: userData.id,
        name: userData.name,
        email: userData.email,
      });

      return {
        success: true,
        user: {
          id: userData.id,
          name: userData.name,
          email: userData.email,
        },
      };
    } catch (error) {
      tokenService.clearAll();
      throw {
        success: false,
        message: error.response?.data?.response || error.message || 'Erro ao fazer login',
      };
    }
  },

  /**
   * Logout
   */
  logout() {
    tokenService.clearAll();
  },

  /**
   * Verifica se está autenticado
   */
  isAuthenticated() {
    return tokenService.isAuthenticated();
  },

  /**
   * Obtém dados do admin logado
   */
  getCurrentUser() {
    return tokenService.getUserData();
  },
};
